/* global PLATFORM, G */
import redirectSequence from 'lib/sequence/module/adapter/router/redirect'
import { asyncPipeSpread } from 'lib/util'
import find from 'lib/sequence/component/children/find'
import { set } from 'lib/sequence/component/state/value'

/**
 * Sets the static content to show.
 *
 * @param {Gaia.AppModule.Spec} module  the current module object composition
 * @returns {function(*, ...[*]): Promise<*[]>}
 */
const setContent = module => async (components, ...args) => {
  const { content } = components

  await module[G.ADAPTER][G.INTL].add(['ecocleanConnect'])

  const value = module[G.ADAPTER][G.INTL].markdown('text', {
    ns: 'ecocleanConnect',
    _key: 'text',
    joinArrays: '\n',
    md: true,
  })

  set(content, value)
  return args
}

/**
 * xEcoApm Connect Action
 *
 * @param {Gaia.AppModule.Spec} module  the current module object composition
 * @returns {function(*): function(...[*]): Promise<*>}
 */
export default module => component => async (...args) => asyncPipeSpread(
  setContent(module),
)(find(component), ...args)
